import React from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import specialtyConfig from './specialtyConfig';

class TypeBySpecialty extends React.Component {

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(this.props.typeByPurpose && this.props.typeByPurpose !== nextProps.typeByPurpose) {
            if (!this.props.typeBySpecialty) return;
            this.props.changeField([{
                field: 'typeBySpecialty',
                value: null,
            }]);
        }
    }

    render() {
        const { getError, changeField, typeBySpecialty, modifiedFields, underStyle, typeByPurpose, fromTcOrder } = this.props;

        let changeLinerMeter = (new RegExp('ro-(ro|lo)', 'i').test(typeBySpecialty)) ? 
            fromTcOrder ?
                [
                    { field: 'linerMeterMin', value: null},
                    { field: 'linerMeterMax', value: null},
                ]
                :
                [
                    { field: 'linerMeter', value: null}
                ]
            :
                []; // \(-_-)/

        return (
            <SelectField
                value={typeBySpecialty}
                disabled={!typeByPurpose}
                onChange={(e, index, value) => {
                    changeField([
                        { field: 'typeBySpecialty', value},
                        ...changeLinerMeter,
                    ]);
                }}
                maxHeight={200}
                name='typeBySpecialty'
                floatingLabelText='Type By Specialty'
                errorText={getError && getError('typeBySpecialty')}
                fullWidth
                autoWidth={true}
                underlineStyle={modifiedFields && modifiedFields.includes('typeBySpecialty') ? underStyle : null}
            >
                {
                    typeByPurpose &&
                        specialtyConfig[typeByPurpose.toLowerCase()].map((specialType, i) => {
                            return (<MenuItem
                                key={i}
                                value={specialType}
                                primaryText={specialType}
                            />);
                        })
                }
            </SelectField>
        );
    }
}

export default TypeBySpecialty;


// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/TypeBySpecialty.jsx